var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilledDashboard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14C19.3125 14 20 14.6875 20 15.5V20.5C20 21.3438 19.3125 22 18.5 22H15.5C14.6562 22 14 21.3438 14 20.5V15.5C14 14.6875 14.6562 14 15.5 14H18.5ZM26.5 20C27.3125 20 28 20.6875 28 21.5V26.5C28 27.3438 27.3125 28 26.5 28H23.5C22.6562 28 22 27.3438 22 26.5V21.5C22 20.6875 22.6562 20 23.5 20H26.5ZM14 25.5C14 24.6875 14.6562 24 15.5 24H18.5C19.3125 24 20 24.6875 20 25.5V26.5C20 27.3438 19.3125 28 18.5 28H15.5C14.6562 28 14 27.3438 14 26.5V25.5ZM26.5 14C27.3125 14 28 14.6875 28 15.5V16.5C28 17.3438 27.3125 18 26.5 18H23.5C22.6562 18 22 17.3438 22 16.5V15.5C22 14.6875 22.6562 14 23.5 14H26.5Z",
    fill: "#1264E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledDashboard);
export default __webpack_public_path__ + "static/media/filledDashboard.e46fd6579097eea609424a434e57e32e.svg";
export { ForwardRef as ReactComponent };